import { createTheme } from "@mui/material/styles";

const textPrimary = "#000000";
const textDisabled = "#929292";

const theme = createTheme({
  typography: {
    fontFamily: `'Poppins', sans-serif`,
    color: `${textPrimary} !important`
  },
  palette: {
    colors: {
      grey1: `#D9D9D9`,
    },
    primary: {
      main: "#2B52D2",
      red: "#D22B2B",
      green: "#2BD24C",
      orange: "#D25B2B",
    },
    secondary: {
      main: "#FF6F20",
    },
    border: {
      main: "#2B52D299",
      disabled: "#929292",
      white: "#ffffff",
    },
    background: {
      default: "#EFEFEF",
      paper: "#FFFFFF",
      card: "#F8F9F9",
    },
    text: {
      default: "#23262C",
      // primary: "#23262C",
      secondary: "#FFFFFF",
      primary: textPrimary,
      // secondary: "#FFFFFF",
      disabled: textDisabled,
      highlight: "#2B52D2",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // This sets the text to have the first letter capitalized
          // and the rest of the letters lowercase, which is the default
          // behavior of 'capitalize' in CSS/MUI.
          textTransform: 'capitalize', 
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: textPrimary, // or use theme.palette.text.default
          "&.Mui-disabled": {
            color: textDisabled, // for disabled state
          },
        },
      },
    },
    MuiTypography: { // <--- Add this section for Typography component styles
      styleOverrides: {
        root: {
          // Styles applied to the root element of all Typography components
          // This can be a good place for general text styling that applies everywhere
          // unless overridden by specific variants.
          // For example, if you want all text to be unselectable by default:
          // userSelect: 'none',
          // color: `${textPrimary} !important`
        },
        h1: {
          // Styles applied to the H1 variant
          fontSize: '3rem',
          fontWeight: 700,
          lineHeight: 1.2,
          color: textPrimary, // Explicitly set color for h1
          marginBottom: '1rem',
          // You can also reference theme values:
          // color: theme.palette.text.primary,
        },
        h2: {
          // Styles applied to the H2 variant
          fontSize: '2.5rem',
          fontWeight: 600,
          lineHeight: 1.3,
          color: textPrimary,
          marginBottom: '0.8rem',
        },
        body1: {
          // Styles applied to the body1 variant (default)
          fontSize: '1rem',
          fontWeight: 400,
          lineHeight: 1.5,
          color: textPrimary, // Use theme.palette.text.primary or textPrimary
        },
        body2: {
          // Styles applied to the body2 variant
          fontSize: '0.875rem',
          fontWeight: 400,
          lineHeight: 1.4,
          color: textDisabled, // Example: body2 could be for less prominent text
        },
        subtitle1: {
          // Styles applied to subtitle1
          fontSize: '1.1rem',
          fontWeight: 500,
          color: textPrimary,
        },
        // You can add styles for any other typography variant like h3, h4, h5, h6, caption, overline, etc.
      },
    },
    // Add styles for TextField placeholder here
    MuiInputBase: { // This targets the common base for all input types (Outlined, Filled, Standard)
      styleOverrides: {
        input: {
          "&::placeholder": { // Target the placeholder pseudo-element
            color: `${textDisabled} !important`, // Example: make placeholder color textDisabled
            opacity: 1, // Ensure the placeholder is not transparent due to browser defaults
          },
        },
      },
    },
  },
});

export default theme;
